<template>
  <v-list-item :to="to" class="items-center d-flex">
    <flag-pip :flag="logo" :text="name" show-tooltip class="mr-2" />
    <base-chip :text="entityType.name" icon="label" color="light-blue" class="mr-2" label small dark />
    <base-chip :text="name" label small dark color="grey darken-2" />
  </v-list-item>
</template>

<script>
import BaseChip from '@/components/chips/base-chip'
import FlagPip from '@/views/news-articles/components/flag-pip'

export default {
  name: 'PageEntityItem',
  components: { BaseChip, FlagPip },
  props: {
    entityTypes: {
      type: Array,
      required: true,
    },
    entity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    entityType() {
      return this.entityTypes.find(({ id }) => this.entity.entity_type_id === id)
    },
    to() {
      return `/entities/${this.entity.id}/manage`
    },
    name() {
      return this.entity.entity.default.name
    },
    logo() {
      return this.entity.entity.default.logoFeatured
    },
  },
}
</script>
